import Http from './http'
import Vue from 'vue'
import moment from 'moment';
import * as Vibrant from 'node-vibrant'

Vue.prototype.$user = {
	isAuthenticated: false,
	app: {}
};

let setUser = _userData => {
	if(_userData.patient.birthdate) {
		_userData.patient.birthdate = moment(_userData.patient.birthdate).format("DD/MM/YYYY");
	}

	if(_userData.patient.logo) {
		// _userData.patient.logo = _userData.patient.logo.split("://")
		// _userData.patient.logo = `${_userData.patient.logo[0].replace("https", "https://").replace("http", "http://")}${_userData.patient.logo[1].replace("//", "/")}`;
		_userData.patient.logo = `data:image/png;base64,${_userData.patient.logo}`;
	}

	Vue.prototype.$user.patient = _userData.patient;
}

let Auth = {

	init(app) {
		const AuthorizationToken = localStorage.getItem('Authorization')

		if(AuthorizationToken != null) {
			Http.defaults.headers.common['Authorization'] = AuthorizationToken
		}
		else
			delete Http.defaults.headers.common['Authorization']

		return this.setAuthenticated()
	},

	/**
	 * Método para autenticação do paciente
	 * @param {Object} Credencial - Dados para login do paciente
	 */
	loginPatient: ({ login, password, dtnasc, loginMethod }) => Http.post('/auth/patient/login', { login, password, dtnasc, loginMethod }),

	checkRegistry: ( data ) => Http.post('/patient/check_registry', data),

	verify: () => {
		return Http.get('/auth/verify')
	},

	setColorPallete: () => Vibrant.from(Vue.prototype.$user.patient.logo),
	// {
	// 	return Vibrant
	// 		.from(_userData.patient.logo)
	// 		.getPalette()
	// 		.then(palette => {
	// 			Vue.prototype.$user.app = {
	// 				...palette
	// 			}
	// 		});
	// }

	/**
	 * Setar usuário global
	 */
	setAuthenticated: () => {
		return Http.get('/auth/verify')
		.then(response => setUser(response.data))
		.then(() => Vue.prototype.$user.isAuthenticated = true)
		.catch((error) => {
			console.log(error);
			Vue.prototype.$user.isAuthenticated = false;
		})
	},

	/**
	 * Retorna se o usuário está autenticado na aplicação
	 */
	isAuthenticated: () => Vue.prototype.$user.isAuthenticated,

	/**
	 * Atualizar informações do usuário no escopo global da aplicação
	 * @param data - Informações do Paciente
	 */
	setUserData: (data) => {
		Vue.prototype.$user.patient = data;
		return Http.post('/auth/patient/update', data);
	},

	/**
	 * Encerrar a seção do paciente
	 */

	logout: () => {
		Vue.prototype.$user = {
			isAuthenticated: false
		}

		localStorage.clear()
	},

	/**
	 * Setar token para proximas autenticacoes
	 */
	setToken: async (token) => {
		Http.defaults.headers.common['Authorization'] = token
		Vue.prototype.$user.isAuthenticated = true;
	},

	/**
	 * Setar dados do usuário
	 */
	setUser: (_userData) => setUser(_userData),
}

export default Auth;


// WEBPACK FOOTER //
// ./src/services/auth.js